import { Card as Mui4Card, CardProps as Mui4CardProps } from '@material-ui/core'
import { default as Mui5Card } from '@mui/material/Card'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'

export enum OsCardVersion {
  V1 = 1, // MUI4
  V2 = 2, // MUI5 + Stratis UI
}
export type CardProps = Mui4CardProps
/** @deprecated Use CardProps */
export type OsCardProps = CardProps

export const Card = forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  const version = useComponentVersion('card')
  switch (version) {
    case OsCardVersion.V2:
      //@ts-ignore
      return <Mui5Card ref={ref} {...props} />

    default:
      return <Mui4Card ref={ref} {...props} />
  }
})
